import axios from 'axios';
import { toast } from "react-toastify";


const API = axios.create({
    baseURL: process.env.REACT_APP_API_BASE_URL,
    headers: {
        'Content-Type': 'application/json'
    }
});






///////////////////////
//
//      DOCUMENT
//
////////////////////////

  export const download_document = async (doc_id) => {
    try {
      const access = localStorage.getItem("access_token");

      const response = await API.get(
        `protected_media/${doc_id}.pdf`,
        {
          headers: {
            Authorization: `Bearer ${access}`,
          },
          responseType: "blob", // <-- important for files
        }
      );

      // Create a link and trigger download
      const blob = new Blob([response.data], { type: "application/pdf" });
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = `${doc_id}.pdf`;
      document.body.appendChild(a);
      a.click();
      a.remove();
      window.URL.revokeObjectURL(url);

      return { success: true };
    } catch (error) {
      console.error("Download failed", error);
      return { success: false, error };
    }
  };


export const view_document = async (doc_id) => {
  try {
    const access = localStorage.getItem("access_token");
    const response = await API.get(
      `protected_media/${doc_id}.pdf`,
      {
        headers: {
          Authorization: `Bearer ${access}`,
        },
        responseType: "blob", // <-- important for files
      }
    );

    // Create a blob URL and open it in a new tab/window
    const blob = new Blob([response.data], { type: "application/pdf" });
    const url = window.URL.createObjectURL(blob);

    // Open in new tab/window
    window.open(url, '_blank');

    // Clean up the URL after a short delay (gives browser time to load)
    setTimeout(() => {
      window.URL.revokeObjectURL(url);
    }, 1000);

    return { success: true };
  } catch (error) {
    console.error("View failed", error);
    return { success: false, error };
  }
};







export const update_document = async (id, data) => {
    try {
        const access = localStorage.getItem('access_token');

        const response = await API.put(`update_document/${id}/`, data, {  // <-- data is added here
            headers: {
                Authorization: `Bearer ${access}`
            }
        });

        return { success: true, data: response.data };
    } catch (error) {
        return manage_error(error, ()=>update_document(id, data));
    }
};



export const create_document = async (data) => {
    try {
        const access = localStorage.getItem('access_token');

        const response = await API.post(`create_document/`, data, {  // <-- data is added here
            headers: {
                Authorization: `Bearer ${access}`,
                'Content-Type': 'application/json'
            }
        });

        if(response && response.data && response.data.status && response.data.status=='ok'){
            console.log("yuppie");
        }

        return { success: true, data: response.data };
    } catch (error) {
        return manage_error(error, ()=>create_document(data));
    }
};





export const delete_document = async (id) => {
    try {
        const access = localStorage.getItem('access_token');

        const response = await API.delete(`documents/`+id+'/', {  // <-- data is added here
            headers: {
                Authorization: `Bearer ${access}`
            }
        });

        return { success: true, data: response.data };
    } catch (error) {
        return manage_error(error, ()=>delete_document(id));
    }
};








export const get_documents = async () => {

        console.log("process.env.REACT_APP_API_BASE_URL");
        console.log(process.env.REACT_APP_API_BASE_URL);
    try {
        const access = localStorage.getItem('access_token');
        console.log("Access token:", access);


        const response = await API.get('documents/', {
            headers: {
                Authorization: `Bearer ${access}`
            }
        });

        console.log("Response:", response);
        return { success: true, data: response.data };
    } catch (error) {
        console.error("Error fetching documents:", error);
        console.log("Error response:", error.response);
        return manage_error(error, () => get_documents());
    }
};


///////////////////////
//
//      TEEAMS
//
////////////////////////



export const get_teams = async () => {

        console.log("process.env.REACT_APP_API_BASE_URL");
        console.log(process.env.REACT_APP_API_BASE_URL);
    try {
        const access = localStorage.getItem('access_token');
        console.log("Access token:", access);


        const response = await API.get('teams/', {
            headers: {
                Authorization: `Bearer ${access}`
            }
        });

        console.log("Response:", response);
        return { success: true, data: response.data };
    } catch (error) {
        console.error("Error fetching documents:", error);
        console.log("Error response:", error.response);
        return manage_error(error, () => get_documents());
    }
};







///////////////////////
//
//      COLORCONFIG + ROLECONFIG
//
////////////////////////



export const get_colorconfig = async () => {
    try {
        const access = localStorage.getItem('access_token');

        const response = await API.get('colorconfig/', {
            headers: {
                Authorization: `Bearer ${access}`
            }
        });

        return { success: true, data: response.data };
    } catch (error) {
        return manage_error(error, get_colorconfig);
    }
};

export const update_colorconfig = async (id, data) => {
    try {
        const access = localStorage.getItem('access_token');
        if(data && data.password === '') delete data.password;
        if(data &&  data.password_confirmation === '') delete data.password_confirmation;

        console.log(data);

        const response = await API.patch(`colorconfig/${id}/`, data, {  // <-- data is added here
            headers: {
                Authorization: `Bearer ${access}`
            }
        });

        return { success: true, data: response.data };
    } catch (error) {
        return manage_error(error, ()=>update_colorconfig(id, data));
    }
};






export const get_roleconfig = async () => {
    try {
        const access = localStorage.getItem('access_token');

        const response = await API.get('roleconfig/', {
            headers: {
                Authorization: `Bearer ${access}`
            }
        });

        return { success: true, data: response.data };
    } catch (error) {
        return manage_error(error, get_roleconfig);
    }
};

export const update_roleconfig = async (id, data) => {
    try {
        const access = localStorage.getItem('access_token');
        if(data && data.password === '') delete data.password;
        if(data &&  data.password_confirmation === '') delete data.password_confirmation;

        const response = await API.patch(`roleconfig/${id}/`, data, {  // <-- data is added here
            headers: {
                Authorization: `Bearer ${access}`
            }
        });

        return { success: true, data: response.data };
    } catch (error) {
        return manage_error(error, ()=>update_roleconfig(id, data));
    }
};


export const create_roleconfig = async (data) => {
    try {
        console.log(data);
        const access = localStorage.getItem('access_token');
        const response = await API.post(`roleconfig/`, data, {  // <-- data is added here
            headers: {
                Authorization: `Bearer ${access}`,
                'Content-Type': 'multipart/form-data' // 👈 key part for Django to recognize file upload
            }
        });

        return { success: true, data: response.data };
    } catch (error) {
        return manage_error(error, ()=>create_roleconfig(data));
    }
};


export const delete_roleconfig = async (id) => {
    try {
        const access = localStorage.getItem('access_token');

        const response = await API.delete(`roleconfig/`+id+'/', {  // <-- data is added here
            headers: {
                Authorization: `Bearer ${access}`
            }
        });

        return { success: true, data: response.data };
    } catch (error) {
        return manage_error(error, ()=>delete_roleconfig(id));
    }
};




///////////////////////
//
//      ALIASES
//
////////////////////////



export const get_alias = async () => {
    try {
        const access = localStorage.getItem('access_token');

        const response = await API.get('alias/', {
            headers: {
                Authorization: `Bearer ${access}`
            }
        });

        return { success: true, data: response.data };
    } catch (error) {
        return manage_error(error, get_alias);
    }
};

export const update_alias = async (id, data) => {
    try {
        const access = localStorage.getItem('access_token');
        if(data && data.password === '') delete data.password;
        if(data &&  data.password_confirmation === '') delete data.password_confirmation;

        const response = await API.patch(`alias/${id}/`, data, {  // <-- data is added here
            headers: {
                Authorization: `Bearer ${access}`
            }
        });

        return { success: true, data: response.data };
    } catch (error) {
        return manage_error(error, ()=>update_alias(id, data));
    }
};

export const create_alias = async (data) => {
    try {
        const access = localStorage.getItem('access_token');
        const response = await API.post(`alias/`, data, {  // <-- data is added here
            headers: {
                Authorization: `Bearer ${access}`,
                'Content-Type': 'multipart/form-data' // 👈 key part for Django to recognize file upload
            }
        });

        return { success: true, data: response.data };
    } catch (error) {
        return manage_error(error, ()=>create_alias(data));
    }
};

export const delete_alias = async (id) => {
    try {
        const access = localStorage.getItem('access_token');

        const response = await API.delete(`alias/`+id+'/', {  // <-- data is added here
            headers: {
                Authorization: `Bearer ${access}`
            }
        });

        return { success: true, data: response.data };
    } catch (error) {
        return manage_error(error, ()=>delete_alias(id));
    }
};













export const get_teamalias = async (q, sort) => {
  try {
    const access = localStorage.getItem('access_token');

    const payload = {
      ...(q ? { q } : {}),
      ...(sort?.length ? { sort } : {})
    };

    const response = await API.post('teamalias/filter/', payload, {
      headers: {
        Authorization: `Bearer ${access}`,
        'Content-Type': 'application/json'
      }
    });

    return { success: true, data: response };
  } catch (error) {
    return manage_error(error, ()=>get_teamalias(q,sort));
  }
};




export const get_teamalias_by_id = async (team_alias_id) => {
  try {
    const access = localStorage.getItem('access_token');

    const response = await API.get('teamalias/'+team_alias_id+"/", {
      headers: {
        Authorization: `Bearer ${access}`,
        'Content-Type': 'application/json'
      }
    });

    return { success: true, data: response };
  } catch (error) {
    return manage_error(error, ()=>get_teamalias_by_id(team_alias_id));
  }
};





export const update_teamalias = async (id, data) => {
    try {
        const access = localStorage.getItem('access_token');
        if(data && data.password === '') delete data.password;
        if(data &&  data.password_confirmation === '') delete data.password_confirmation;

        const response = await API.patch(`teamalias/${id}/`, data, {  // <-- data is added here
            headers: {
                Authorization: `Bearer ${access}`
            }
        });

        return { success: true, data: response.data };
    } catch (error) {
        return manage_error(error, ()=>update_teamalias(id, data));
    }
};

export const create_teamalias = async (data) => {
    try {
        const access = localStorage.getItem('access_token');
        const response = await API.post(`teamalias/`, data, {  // <-- data is added here
            headers: {
                Authorization: `Bearer ${access}`,
                'Content-Type': 'multipart/form-data' // 👈 key part for Django to recognize file upload
            }
        });

        return { success: true, data: response.data };
    } catch (error) {
        return manage_error(error, ()=>create_teamalias(data));
    }
};

export const delete_teamalias = async (id) => {
    try {
        const access = localStorage.getItem('access_token');

        const response = await API.delete(`teamalias/`+id+'/', {  // <-- data is added here
            headers: {
                Authorization: `Bearer ${access}`
            }
        });

        return { success: true, data: response.data };
    } catch (error) {
        return manage_error(error, ()=>delete_teamalias(id));
    }
};




///////////////////////
//
//      WATCHLISTS & LOGOS
//
////////////////////////




export const get_watchlists = async () => {
    try {
        const access = localStorage.getItem('access_token');

        const response = await API.get('watchlists/', {
            headers: {
                Authorization: `Bearer ${access}`
            }
        });

        return { success: true, data: response.data };
    } catch (error) {
        return manage_error(error, get_watchlists);
    }
};



export const get_logos = async () => {
    try {
        const access = localStorage.getItem('access_token');

        const response = await API.get('logos/', {
            headers: {
                Authorization: `Bearer ${access}`
            }
        });

        return { success: true, data: response.data };
    } catch (error) {
        return manage_error(error, get_logos);
    }
};





export const get_watchlist_logo_associations = async () => {
    try {
        const access = localStorage.getItem('access_token');

        const response = await API.get('watchlistlogo/', {
            headers: {
                Authorization: `Bearer ${access}`
            }
        });

        return { success: true, data: response.data };
    } catch (error) {
        return manage_error(error, get_watchlist_logo_associations);
    }
};





export const logos_by_watchlist = async (watchlist_id) => {
    try {
        const access = localStorage.getItem('access_token');

        const response = await API.post('logos_by_watchlist/', {
            watchlist_id: watchlist_id,
        }, {
            headers: {
                Authorization: `Bearer ${access}`
            }
        });


        return { success: true, data: response.data };
    } catch (error) {
        return manage_error(error,  ()=>logos_by_watchlist(watchlist_id));
    }
};





export const associate_logos = async (watchlist_id, array) => {
    try {
        const access = localStorage.getItem('access_token');

        const response = await API.post('associate_logos/', {
            watchlist_id: watchlist_id,
            logo_ids: array
        }, {
            headers: {
                Authorization: `Bearer ${access}`
            }
        });


        return { success: true, data: response.data };
    } catch (error) {
        return manage_error(error,  ()=>associate_logos(watchlist_id, array));
    }
};


///////////////////////
//
//      USERS
//
////////////////////////



export const get_users = async () => {
    try {
        const access = localStorage.getItem('access_token');

        const response = await API.get('users/', {
            headers: {
                Authorization: `Bearer ${access}`
            }
        });

        return { success: true, data: response.data };
    } catch (error) {
        return manage_error(error, get_users);
    }
};

export const update_user = async (id, data) => {
    try {
        const access = localStorage.getItem('access_token');
        if(data && data.password === '') delete data.password;
        if(data &&  data.password_confirmation === '') delete data.password_confirmation;

        const response = await API.patch(`users/${id}/`, data, {  // <-- data is added here
            headers: {
                Authorization: `Bearer ${access}`
            }
        });

        return { success: true, data: response.data };
    } catch (error) {
        return manage_error(error, ()=>update_user(id, data));
    }
};

export const create_user = async (data) => {
    try {
        const access = localStorage.getItem('access_token');
        const response = await API.post(`users/`, data, {  // <-- data is added here
            headers: {
                Authorization: `Bearer ${access}`,
                'Content-Type': 'multipart/form-data' // 👈 key part for Django to recognize file upload
            }
        });

        return { success: true, data: response.data };
    } catch (error) {
        return manage_error(error, ()=>create_user(data));
    }
};

export const delete_user = async (id) => {
    try {
        const access = localStorage.getItem('access_token');

        const response = await API.delete(`users/`+id+'/', {  // <-- data is added here
            headers: {
                Authorization: `Bearer ${access}`
            }
        });

        return { success: true, data: response.data };
    } catch (error) {
        return manage_error(error, ()=>delete_user(id));
    }
};


///////////////////////
//
//      LOGIN AND SUCH
//
////////////////////////





export const manage_call_result = (res) => {
  if(res && res.success===false){
    if(typeof(res.error)==='string'){
          debugger;

      toast.error("Errore imprevisto, si prega di riprovare.");
      return false;
    }
    var errs = Object.entries(res.error);
    var message = "";
    errs.forEach((e)=>{
      if(e && e[0] && e[1]){
        message = e[0]+": "+e[1];
        toast.error(message);
      }
    });
    return false;
  }
  return true;
}




export const manage_error = async (error, callback) => {
  console.log("MANAGING ERROR");
  if(error.status && error.status === 401){
    await refreshToken();
  }
  else{
    if(error){
      return { success: false, error: error.response ? error.response.data : error.message };
    }
  }

  try {
      var response = await callback();
      return { success: true, data: response.data };
  } catch (error) {
      return { success: false, error: error.response ? error.response.data : error.message };
  }

}





const convertDateFormat = (dateStr) => {
  // Split the input string by "/"
  console.log("DATE BEFORE: ");
  console.log(dateStr);
  const [day, month, year] = dateStr.split("/");
  // Return in yyyy-mm-dd format
  const new_str =  `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
  console.log("DATE AFTER: ");
  console.log(new_str);
  return new_str
}


const format_all_dates_in_object = (obj) => {
  console.log("CONVERTING DATES NOOOOWWW");
  const newObj = { ...obj }; // Make a shallow copy to avoid mutating the original
  for (const key in newObj) {
    if (
      key.toLowerCase().includes("date") &&
      typeof newObj[key] === "string" &&
      /^\d{2}\/\d{2}\/\d{4}$/.test(newObj[key])
    ) {
      newObj[key] = convertDateFormat(newObj[key]);
    }
    else if (
      key.toLowerCase().includes("date") &&
      typeof newObj[key] === "object"
    ) {
      const the_date = newObj[key];

      if(!newObj[key]){
        newObj[key] = null;
      }
      else{
        const yyyy = the_date.getFullYear();
        const mm = String(the_date.getMonth() + 1).padStart(2, '0'); // Months are 0-based
        const dd = String(the_date.getDate()).padStart(2, '0');
        const formattedDate = `${yyyy}-${mm}-${dd}`;
        newObj[key] = formattedDate;
      }


    }
  }
  return newObj;
}






// Function to login and get tokens
export const login = async (email, password) => {
    try {
        const response = await API.post('token/', { email, password });
        const { access, refresh } = response.data;



        localStorage.setItem('access_token', access);
        localStorage.setItem('refresh_token', refresh);

        const response_userinfo = await API.get('user_info/?email='+email, {headers: {
                Authorization: `Bearer ${access}`
          }
        });

        if(response_userinfo && response_userinfo.data){
            localStorage.setItem('first_name', response_userinfo.data.first_name);
            localStorage.setItem('last_name', response_userinfo.data.last_name);
            localStorage.setItem('role', response_userinfo.data.role);
            localStorage.setItem('user_id', response_userinfo.data.id);
            return { success: true };
        }
        else{
            return { success: false, error: "could not retrieve user data" };
        }

    } catch (error) {
        return { success: false, error: error.response?.data };
    }
};

// Function to refresh token
export const refreshToken = async () => {
    try {
        const refresh = localStorage.getItem('refresh_token');
        if (!refresh) throw new Error("No refresh token found");

        const response = await API.post('token/refresh/', { refresh });
        localStorage.setItem('access_token', response.data.access);

        return response.data.access;
    } catch (error) {
        console.error(error);
        debugger;
        logout();
        return null;
    }
};

// Function to verify token
export const verifyToken = async () => {

    const access = localStorage.getItem('access_token');
    if (!access) return false;

    try {
        await API.post('token/verify/', { token: access });
        return true;
    } catch {
        return false;
    }
};











// Function to log out
export const logout = () => {
    localStorage.removeItem('access_token');
    localStorage.removeItem('refresh_token');
    window.location.href = 'login'; // Refresh page to clear state
};



export default API;
